import React from 'react'
import Project from '../layouts/Project'
import { projects, writings, miscellaneous, section3Title, section3Pt1Title, section4Title } from '../../profile'

const Works = () => {
    return (
        <>
            <div data-aos="zoom-in-up" data-aos-once="true" className="third">
                <>
                    <div className="pp-head-line mx-auto text-center">
                        <h1 id="Projects" className="red-line pp-head">{section3Pt1Title}</h1>
                    </div>
                </>
                <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
                    {writings && writings.map((x) =>
                        <Project key={x.id} id={x.id} url={x.url} name={x.name} skills={x.skills} />
                    )}
                </div>
            </div>
            <div data-aos="zoom-in-up" data-aos-once="true" className="third">
                <>
                    <div className="pp-head-line mx-auto text-center">
                        <h1 id="Projects" className="red-line pp-head">{section3Title}</h1>
                    </div>
                </>
                <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
                    {projects && projects.map((x) =>
                        <Project key={x.id} id={x.id} url={x.url} name={x.name} skills={x.skills} />
                    )}
                </div>
            </div>

            <div className="third">
                <>
                    <div className="pp-head-line mx-auto text-center" style={{ width: '40%' }}>
                        <h1 id="Projects" className="red-line pp-head" >{section4Title}</h1>
                    </div>
                </>
                <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
                    {miscellaneous && miscellaneous.map((x) =>
                        <Project key={x.id} id={x.id} url={x.url} name={x.name} />
                    )}
                </div>
            </div>
        </>
    )
}

export default Works
